// FAQ page js
console.log('pagina de FAQ')
let MainContainer = document.querySelector('#MainContent')
if (MainContainer) {
  if (MainContainer.querySelector('.FAQ-container-wrapper')) {
    console.log('numa daca exita FAQs')
    MainContainer.addEventListener('click', (e) => {
      if (e.target.closest('.FAQ__q-wrapper')) {
        console.log('sa apasat pe open q', e.target)
        console.log('cel mai aproep', e.target.closest('.FAQ__wrapper'))
        //remove all opened questions on page
        if (!e.target.closest('.FAQ__wrapper').classList.contains('open')) {
          MainContainer.querySelectorAll('.FAQ__wrapper.open').forEach(el => {
            el.classList.remove('open');
          }
          )
        }
        e.target.closest('.FAQ__wrapper').classList.toggle('open')
      }
    })
  }
}